<template>
  <main :class="['login', { login2: !show }]">
    <!-- 左边服务说明 -->
    <LeftService v-if="isAiChdesign" />
    <!-- 右边登录区域 -->
    <!-- <RightLogin /> -->
    <div class="right">
      <LeftService2 v-if="!show && this.$route.query?.hidden !== 'true'" />
      <NewRightLogin :show="show" />
      <!-- <RightLogin :show="show" /> -->
    </div>
  </main>
</template>

<script>
import LeftService from "./components/leftService.vue";
import LeftService2 from "./components/leftService2.vue";
// import RightLogin from "./components/rightLogin.vue";
import NewRightLogin from "./components/newRightLogin.vue";

export default {
  name: "Login",
  components: {
    LeftService,
    LeftService2,
    // RightLogin,
    NewRightLogin,
  },
  data() {
    return {
      show: this.$route.query?.clientType !== "IYW",
      isAiChdesign: this.$route.query?.from !== "aiChdesign",
    };
  },
  mounted() {
    !this.isAiChdesign ? (document.title = "ai生图平台") : "";
  },
};
</script>
<style lang="scss" scoped>
.login {
  height: 100%;
  display: flex;
  align-items: center;

  .right {
    flex: 1;
    display: flex;
    justify-content: center;
  }
}

.login2 {
  background-color: rgba($color: #000000, $alpha: 0.6);

  .leftService {
    display: none;
  }
}
</style>
